// Vendor imports
const { combineReducers } = require('redux-immutable')
// Entry imports
const RootRecord = require('client-v2/logged-out-landing-v2/state/record')

const reducers = {
  // Common state
  ...require('client-v2/common/state/reducers'),
  // Entry containers
  bannerSection: require('client-v2/logged-out-landing-v2/containers/banner-section/reducer'),
  heroSection: require('client-v2/logged-out-landing-v2/containers/hero-section/reducer')
}

module.exports = combineReducers(
  reducers,
  () => new RootRecord()
)
